import { IoIosArrowDroprightCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import secondPartImg from "../../asset/images/home/second-part-img.png";
import { ABOUT_US, ABOUT_US_TEXT } from "../../constants/translations";
import scrollToTop from "../../hybrids/functions/scrollToTop";
import { ABOUT_US_ROUTE } from "../../routes/routes";

const AboutUs = () => {
  return (
    <section className="about-us-part">
      <div className="about-us-img">
        <img src={secondPartImg} alt="Another Ship" />
      </div>
      <div className="about-us-text-content">
        <div className="au-content-wrapper">
          <p className="about-us-text">{ABOUT_US_TEXT}</p>
          <Link
            to={ABOUT_US_ROUTE}
            onClick={scrollToTop}
            className="main-btn about-us-btn"
          >
            {ABOUT_US}
            <IoIosArrowDroprightCircle />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
